var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login',{attrs:{"module":_vm.module,"googleClientId":_vm.googleClientId,"port":_vm.port}})
}
var staticRenderFns = []

export { render, staticRenderFns }